<template>
  <section class="Sr_Nav_Page">
    <div class="work-inner">
      <el-row>
        <el-col :span="24">
          <div class="nav">
            <img
              :src="configData[type].image"
              alt
              style="width: 48px; height: auto"
            />
            <div class="nav_title">
              <div id="titleHasTrack" class="title">
                {{
                  project[configData[type].title]
                    ? project[configData[type].title]
                    : "-"
                }}
              </div>
              <div
                v-if="configData[type].name && type != '5'"
                class="bottom_box"
              >
                <div class="workNumbering">
                  <label>{{ configData[type].name }}:</label>
                  <span>
                    {{
                      project[configData[type].code]
                        ? project[configData[type].code]
                        : "-"
                    }}
                  </span>
                </div>
                <span
                  v-if="project[configData[type].unitName] && type == 6"
                  class="divider"
                ></span>
                <div
                  class="workNumbering"
                  v-if="project[configData[type].unitName] && type == 6"
                >
                  <label>{{ configData[type].unit }}:</label>
                  <span>
                    {{ project[configData[type].unitName] }}
                  </span>
                </div>
              </div>

              <div v-else class="expertWorkNumbering">
                <div class="workNumbering">
                  <label
                    ><i class="el-icon-phone"></i>
                    {{ project[configData[type].phone] }}</label
                  >
                  <label>
                    <i class="el-icon-location-outline"></i>
                    {{ project[configData[type].address] }}</label
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>
    </div>
  </section>
</template>
<script>
import planImg from "./plan.png";
import projectImg from "./project.png";
import yearPlanImg from "./yearPlan.jpg";
import taskImg from "./task.png";
import zhuanjia from "./zhuanjia.png";
export default {
  name: "SrNavPage",
  props: {
    project: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: Number,
      default: () => {
        return 1; // 1是规划头部，2是项目头部
      },
    },
    tooltipFlag: {
      type: Boolean,
      default: () => {
        return false; // 项目名过长是否隐藏
      },
    },
  },
  data() {
    return {
      configData: {
        1: {
          image: planImg,
          title: "name",
          name: "规划编号",
          code: "code",
        },
        2: {
          image: projectImg,
          title: "projectName",
          name: "项目编号",
          code: "projectCode",
        },
        3: {
          image: yearPlanImg,
          title: "yearPlanName",
          name: "年度项目计划编号",
          code: "yearPlanCode",
        },
        4: {
          image: taskImg,
          title: "taskName",
        },
        5: {
          title: "name",
          image: zhuanjia,
          phone: "phone",
          address: "addressName",
        },
        6: {
          image: projectImg,
          title: "projectName",
          name: "项目编号",
          code: "projectCode",
          unit: "需求单位",
          unitName: "unitName",
        },
      },
    };
  },
  mounted() {
    setTimeout(() => {
      if (
        document.querySelector(".bz-traceTrackView") &&
        document.querySelector(".bz-traceTrackView").children.length != 0 &&
        this.$route.query.processId
      ) {
        this.$nextTick(() => {
          document.getElementById("titleHasTrack").style.marginRight =
            130 + "px";
          console.log(document.getElementById("titleHasTrack"));
        });
      }
    }, 300);
  },
  methods: {},
};
</script>



// WEBPACK FOOTER //
// packages/SrNavPage/index.vue